export function studyIntakeForm(args) {
  return {
    formValues: args.initialValues || {},
    questions: args.questions || [],

    init() {
      this.initializeCheckboxValidation();
    },

    updateCheckboxGroupValidation(container) {
      const isRequired = container.dataset.required === "true";
      if (!isRequired) return;

      const checkboxes = Array.from(
        container.querySelectorAll('input[type="checkbox"]'),
      );
      const anyChecked = checkboxes.some((cb) => cb.checked);

      checkboxes.forEach((checkbox) => {
        if (anyChecked) {
          checkbox.removeAttribute("required");
        } else {
          checkbox.setAttribute("required", "required");
        }
      });
    },

    initializeCheckboxValidation() {
      document
        .querySelectorAll(".multi-select-checkboxes")
        .forEach((group) => this.updateCheckboxGroupValidation(group));
    },

    normalizeValue(value) {
      if (!value) return value;

      if (Array.isArray(value)) {
        return value.map((v) => v.toString().toLowerCase()).sort();
      }

      return value.toString().toLowerCase();
    },

    valuesMatch(parentValue, conditionValues) {
      if (Array.isArray(parentValue)) {
        const parentStr = this.normalizeValue(parentValue).join(",");
        const conditionStr = this.normalizeValue(conditionValues).join(",");

        return parentStr === conditionStr;
      }

      return (
        this.normalizeValue(conditionValues[0]) ===
        this.normalizeValue(parentValue)
      );
    },

    shouldShowConditionalQuestion(isChild, parentKey, question) {
      if (!isChild) return true;

      const parentValue = this.formValues[parentKey];
      const condition = question.condition;

      if (!condition || !parentValue || parentValue.length === 0) return false;

      switch (condition.operator) {
        case "equals":
          return this.valuesMatch(parentValue, condition.values);

        case "does_not_equal":
          return !this.valuesMatch(parentValue, condition.values);

        case "contains":
          if (Array.isArray(parentValue)) {
            return condition.values.some((v) =>
              this.normalizeValue(parentValue).includes(this.normalizeValue(v)),
            );
          }

          return condition.values.some((v) =>
            this.normalizeValue(parentValue).includes(this.normalizeValue(v)),
          );

        case "does_not_contain":
          if (Array.isArray(parentValue)) {
            return !condition.values.some((v) =>
              this.normalizeValue(parentValue).includes(this.normalizeValue(v)),
            );
          }

          return !condition.values.some((v) =>
            this.normalizeValue(parentValue).includes(this.normalizeValue(v)),
          );

        default:
          return false;
      }
    },

    updateValue(key, value) {
      this.formValues[key] = this.normalizeValue(value);
    },

    updateCheckboxValue(key, event) {
      const container = event.target.closest(".multi-select-checkboxes");
      const checked = Array.from(
        container.querySelectorAll('input[type="checkbox"]:checked'),
      ).map((cb) => cb.value);

      this.formValues[key] = this.normalizeValue(checked);
    },

    updateMultiSelectValue(key, selectedIndices) {
      const selectedIndicesAsStrings = selectedIndices.map((idx) =>
        idx.toString(),
      );
      this.formValues[key] = this.normalizeValue(selectedIndicesAsStrings);
    },

    validateLongText(event) {
      const textarea = event.target;
      const isRequired = textarea.hasAttribute("required");

      if (isRequired && textarea.value.trim() === "") {
        textarea.setCustomValidity("Empty responses are not allowed");
      } else {
        textarea.setCustomValidity("");
      }
    },
  };
}
